<div class="customer-billing-info">
  <div class="heading">
    <div>
      <span>{{ 'label.Billing' | translate }}</span>
    </div>
    <div>
      <a
        *ngIf="customer?.statusId == customerStatusEnum.Active"
        [routerLink]="
          customer ? ['/customers/edit/', customer?.customerId, 'billing'] : []
        "
        >{{ 'label.Edit' | translate }}</a
      >
    </div>
  </div>
  <div class="content">
    <div>
      <div>{{ 'label.TaxId' | translate }}:</div>
      <div>{{ customer?.idNumber }}</div>
    </div>
    <div>
      <div>{{ 'label.LegalName' | translate }}:</div>
      <div>{{ customer?.legalName }}</div>
    </div>
    <div>
      <div>{{ 'label.LegalAddress' | translate }}:</div>
      <div>{{ customer?.legalAddress }}</div>
    </div>
    <div>
      <div>{{ 'label.VatStatus' | translate }}:</div>
      <div>{{ customer?.accountDetails?.vatStatus }}</div>
    </div>
  </div>
</div>
